import React from "react";
import { Button, Checkbox, Input, Option, Select } from "@material-tailwind/react";
import { convertToPresentableText } from "../../../utils/functions";
import {
  SALES_CYCLE_LENGTHS_ENUM
} from "../../../utils/enums";
import { PlusIcon, Trash2Icon } from "lucide-react";

const QualificationTab = ({ formData, handlers, arrayState }) => {
  const {
    handleInputChange,
    handleSelectChange,
    handleCheckBoxChange,
    handleAddPainPoint,
    handleRemovePainPoint,
    handleAddRequirement,
    handleRemoveRequirement,
    handleAddSolutionInterest,
    handleRemoveSolutionInterest,
    handleAddCompetitor,
    handleRemoveCompetitor
  } = handlers;

  const {
    newPainPoint,
    setNewPainPoint,
    newRequirement,
    setNewRequirement,
    newSolutionInterest,
    setNewSolutionInterest,
    newCompetitor,
    setNewCompetitor
  } = arrayState;

  return (
    <div className="space-y-4">
      <div className="flex gap-4 flex-col md:flex-row">
        <Input
          label="Budget Range"
          name="budgetRange"
          value={formData.budgetRange}
          onChange={handleInputChange}
        />
        <Select
          label="Decision Timeline"
          value={formData.decisionTimeline}
          onChange={(value) => handleSelectChange("decisionTimeline", value)}
        >
          {SALES_CYCLE_LENGTHS_ENUM.map((timeline, index) => (
            <Option key={index} value={timeline}>
              {convertToPresentableText(timeline)}
            </Option>
          ))}
        </Select>
        <div className="w-full">
          <Checkbox
            name="isDecisionMaker"
            checked={formData.isDecisionMaker}
            onChange={handleCheckBoxChange}
            label="Is Decision Maker"
          />
        </div>
      </div>

      <div className="flex gap-4 flex-col md:flex-row">
        <Input
          label="Decision Process"
          name="decisionProcess"
          value={formData.decisionProcess}
          onChange={handleInputChange}
          className="w-full"
        />
      </div>
      <div className="flex gap-4 flex-col md:flex-row">
        <div className="w-full md:w-1/2">
          <Input
            label={`Lead Score 0-100 (${formData.score || 0})`}
            name="score"
            type="range"
            min="0"
            max="100"
            value={formData.score || 0}
            onChange={handleInputChange}
          />
        </div>
        <div className="w-full md:w-1/2">
          <Input
            label={`Conversion Probability (${formData.conversionProbability || 0}%)`}
            name="conversionProbability"
            type="range"
            min="0"
            max="100"
            value={formData.conversionProbability || 0}
            onChange={handleInputChange}
          />
        </div>
      </div>
      <div className="flex gap-4 flex-col md:flex-row">
        <div className="w-full md:w-1/2">
          <div className="border p-3 rounded-md">
            <div className="flex gap-2">
              <Input
                label="Add Pain Point"
                value={newPainPoint}
                onChange={(e) => setNewPainPoint(e.target.value)}
                className="flex-grow"
              />
              <Button variant="filled" className="rounded-full px-3" onClick={handleAddPainPoint}>
                <PlusIcon size={16} />
              </Button>
            </div>
            <div className="mt-2">
              {formData.painPoints?.map((item, index) => (
                <div key={index} className="flex justify-between items-center px-3 py-2 bg-gray-50 rounded mt-1">
                  <span className="text-sm">{item}</span>
                  <Button variant="text" className="rounded-full px-3" onClick={() => handleRemovePainPoint(index)}>
                    <Trash2Icon size={12} color="red" />
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/2">
          <div className="border p-3 rounded-md">
            <div className="flex gap-2">
              <Input
                label="Add Requirement"
                value={newRequirement}
                onChange={(e) => setNewRequirement(e.target.value)}
                className="flex-grow"
              />
              <Button variant="filled" className="rounded-full px-3" onClick={handleAddRequirement}>
                <PlusIcon size={16} />
              </Button>
            </div>
            <div className="mt-2">
              {formData.requirements?.map((item, index) => (
                <div key={index} className="flex justify-between items-center p-2 bg-gray-50 rounded mt-1">
                  <span className="text-sm">{item}</span>
                  <Button variant="text" className="rounded-full px-3" onClick={() => handleRemoveRequirement(index)}>
                    <Trash2Icon size={12} color="red" />
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-4 flex-col md:flex-row">
        <div className="w-full md:w-1/2">
          <div className="border p-3 rounded-md">
            <div className="flex gap-2">
              <Input
                label="Add Solution Interest"
                value={newSolutionInterest}
                onChange={(e) => setNewSolutionInterest(e.target.value)}
                className="flex-grow"
              />
              <Button variant="filled" className="rounded-full px-3" onClick={handleAddSolutionInterest}>
                <PlusIcon size={16} />
              </Button>
            </div>
            <div className="mt-2">
              {formData.solutionInterest?.map((item, index) => (
                <div key={index} className="flex justify-between items-center p-2 bg-gray-50 rounded mt-1">
                  <span className="text-sm">{item}</span>
                  <Button variant="text" className="rounded-full px-3" onClick={() => handleRemoveSolutionInterest(index)}>
                    <Trash2Icon size={12} color="red" />
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/2">
          <div className="border p-3 rounded-md">
            <div className="flex gap-2">
              <Input
                label="Add Competitor"
                value={newCompetitor}
                onChange={(e) => setNewCompetitor(e.target.value)}
                className="flex-grow"
              />
              <Button variant="filled" className="rounded-full px-3" onClick={handleAddCompetitor}>
                <PlusIcon size={16} />
              </Button>
            </div>
            <div className="mt-2">
              {formData.competitorConsideration?.map((item, index) => (
                <div key={index} className="flex justify-between items-center p-2 bg-gray-50 rounded mt-1">
                  <span className="text-sm">{item}</span>
                  <Button variant="text" className="rounded-full px-3" onClick={() => handleRemoveCompetitor(index)}>
                    <Trash2Icon size={12} color="red" />
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default QualificationTab;